<template>
  <CSidebarNav>
    <PublisherSidebarItem :list="mainList || main" />
    <li class="nav-title">{{ settings.title }}</li>
    <PublisherSidebarItem :list="settingsList || settings" />
  </CSidebarNav>
</template>

<script>
import routerPublisher from '@/publisher/router'
import { useRoute } from 'vue-router'
import { onMounted, ref } from 'vue'
import PublisherSidebarItem from '@/publisher/views/sidebar/MenuItem.vue'
import { main, settings } from '@/publisher/views/assets/sidebar'

export default {
  name: 'PublisherSidebar',

  components: {
    PublisherSidebarItem,
  },

  setup() {
    const route = useRoute()
    const mainList = ref()
    const settingsList = ref()

    const normalizePath = (path) => {
      return decodeURI(path)
        .replace(/#.*$/, '')
        .replace(/(index)?\.(html)$/, '')
    }

    const isItemActive = (item) => {
      if (item.to === undefined) {
        return false
      }

      if (route.hash === item.to) {
        return true
      }

      const currentPath = normalizePath(route.path)
      const targetPath = normalizePath(item.to)

      return currentPath === targetPath
    }

    const getList = (items) => {
      return items?.map((item) => {
        return {
          ...item,
          isActive: isItemActive(item),
        }
      })
    }

    routerPublisher.afterEach(() => {
      mainList.value = getList(main)
      settingsList.value = getList(settings)
    })

    onMounted(() => {
      mainList.value = getList(main)
      settingsList.value = getList(settings)
    })

    return {
      mainList,
      settingsList,
    }
  },

  data() {
    return {
      main: main,
      settings: {
        title: 'Settings',
        items: settings,
      },
    }
  },
}
</script>
